import { Button, type ButtonProps } from "@fluentui/react-components";
import * as React from "react";

export type TriggerButtonProps = ButtonProps;

export const TriggerButton = (props: TriggerButtonProps) => {
  const { onClick, disabled, ...otherProps } = props;
  const [isDisabled, setIsDisabled] = React.useState(disabled || false);
  const handleClick:
    | React.MouseEventHandler<HTMLButtonElement>
    | React.MouseEventHandler<HTMLAnchorElement>
    | undefined = React.useCallback(
    (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent> &
        React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
      if (onClick) {
        setIsDisabled(true);
        onClick(event);
      }
    },
    [onClick]
  );

  React.useEffect(() => {
    setIsDisabled(disabled || false);
  }, [disabled]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (
    <Button
      {...otherProps}
      onClick={handleClick as any}
      disabled={isDisabled}
    />
  );
};
